import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react'
import favicon from "./../../../assets/images/favicon.ico"
import "./doctors.css"
import poovizhidoc from './../../../assets/images/Doctorsimages/poovizhidr.png'
import muthumari from '../../../assets/images/Doctorsimages/dr.muthumari.png'
import pavithra from '../../../assets/images/Doctorsimages/dr.pavithra.png'
import yuvapriya from '../../../assets/images/Doctorsimages/dr.yuvapriya.png'
import veena from '../../../assets/images/Doctorsimages/dr.veena.png'
import Chayanika from '../../../assets/images/Doctorsimages/dr.Chayanika.png'
import yuganthi from '../../../assets/images/Doctorsimages/dr.yuganthi.png'
import aswini from '../../../assets/images/Doctorsimages/dr.aswini.png'
import ahilan from '../../../assets/images/Doctorsimages/dr.Ahilan_new.png'
import pargavi from '../../../assets/images/Doctorsimages/dr.pargavi.png'
import spoorthi from '../../../assets/images/Doctorsimages/dr.spoothi_new.png'
import renuka from '../../../assets/images/Doctorsimages/dr.renuka_new.png'
import umabarathidoc from '../../../assets/images/Doctorsimages/UMABARATHIDR.png'
import dharshandoc from '../../../assets/images/Doctorsimages/DHARSHANDR.png'
import sarbarmathydr from '../../../assets/images/Doctorsimages/sarbarmathydr.png'
import balajidoc from '../../../assets/images/Doctorsimages/BALAJIDR.png'
import NELOFARDOC from '../../../assets/images/Doctorsimages/NELOFARDOC.png'
import hcuravideo from '../../../assets/video/hcura-hero2.mp4'
import sharmiladoc from '../../../assets/images/Doctorsimages/dr.sharmila.png'
import indhumathidoc from '../../../assets/images/Doctorsimages/dr.indhumathi.png'
import mohandr from './../../../assets/images/Doctorsimages/drmohan .png'
import snegadoc from './../../../assets/images/Doctorsimages/dr.snega.png'
import monekadoc from './../../../assets/images/Doctorsimages/monekadr.png'
import keerthanadoc from './../../../assets/images/Doctorsimages/keerthanadoc.png' // Ensure this path/image exists
import abarnadoc from './../../../assets/images/Doctorsimages/abarnadoc.png' // Ensure this path/image exists
import supriyadr from './../../../assets/images/Doctorsimages/supriyadr.png' // Ensure this path/image exists
import navyadr from './../../../assets/images/Doctorsimages/navyadr.png'
import afiladr from './../../../assets/images/Doctorsimages/afiladr.png' // Ensure this path/image exists
import yuvashreedr from './../../../assets/images/Doctorsimages/yuvashreedr.png' // Ensure this path/image exists
import prathyaushadr from './../../../assets/images/Doctorsimages/prathyaushadr.png' // Ensure this path/image exists
import saiharishthadr from './../../../assets/images/Doctorsimages/saiharishthadr.png' // Ensure this path/image exists
import arifadoc from './../../../assets/images/Doctorsimages/afriadoc.png' // Ensure this path/image exists
import vigneshdr from './../../../assets/images/Doctorsimages/vigneshdr.png'
import vinithadoc from './../../../assets/images/Doctorsimages/vinithadr.jpeg'
import shaharinDoc from './../../../assets/images/Doctorsimages/Shaharindr.png'


import {FaRegLightbulb, FaShieldAlt,} from 'react-icons/fa';

const doctors = [
  // {
  //   id: 1,
  //   name: "Dr. Krishnamoorthy Balaji",
  //   specialization: "Dental Specialist",
  //   address: "MDS (Orthodontist and Implantologist) | Exp. 33+ years",
  //   rating: "4.8",
  //   image: balajidoc,
  //    slug: "dr-krishnamoorthy-balaji"
  // },
  // {
  //   id: 1,
  //   name: "Dr.Renuka",
  //   specialization: "Homeopathy Specialist",
  //   address: "BHMS | Exp. 15+ years",
  //   rating: "4.8",
  //   image: renuka,
  //    slug: "dr-renuka-e-best-homeopathy-doctor-jayanagar-bangalore"
  // },
   {
    id: 1,
    name: "DR.VIGNESH KUMAR R",
    specialization: "Dermatology Specialist | Aesthetic Specialist",
    address: "MBBS , DDVL | Exp. 16+ years",
    rating: "4.7",
    image: vigneshdr,
     slug: "dr-r-vignesh-kumar-clinical-director-dermatology"
  },
  {
    id: 2,
    name: "DR.ARIFA J",
    specialization: "Dental Specialist",
    address: "BDS | Exp. 9+ years",
    rating: "4.7",
    image: arifadoc,
     slug: "dr-arifa-j-dentist-chennai"
  },
  
  {
    id: 3,
    name: "DR. SPOORTHI PRASAD",
    specialization: "Homeopathy Specialist",
    address: "BHMS | Exp. 8+ years",
    rating: "4.7",
    image: spoorthi,
      slug: "dr-spoorthi-prasad-senior-homeopathy-doctor-jayanagar-bangalore"
  },
   {
    id: 4,
    name: "DR. SYED NELOFAR",
    specialization: "Aesthetic Specialist | Homeopathy Specialist",
    address: "BHMS ,CGO ,CCH ,FFAC ,ADCT | Exp. 6+ years",
    rating: "4.7",
    image: NELOFARDOC,
      slug: "dr-syed-nelofar-aesthetic-homoeopathy-bangalore"
  },
  {
    id: 5,
    name: "DR.PRATHYUSHA R",
    specialization:  "Aesthetic Specialist | Dental Specialist",
    address: "BDS, MDS | Exp. 6+ years",
    rating: "4.7",
    image: prathyaushadr,
     slug: "dr-prathyusha-r-maxillofacial-surgery-and-cosmetology-chennai"
  }
  ,{
    id: 6,
    name: "DR .SABARMATHY",
    specialization: "Aesthetic Specialist | Dental Specialist",
    address: "BDS, FELLOWSHIP IN COSMETIC SCIENCE & SEMI PERMANENT MAKEUP  | Exp. 6+ years",
    rating: "4.7",
    image: sarbarmathydr,
     slug: "dr-sabarmathy-dentist-aesthetic-pondicherry"
  },
   {
    id: 7,
    name: "DR.SUPRIYA",
    specialization:  "Aesthetic Specialist | Dental Specialist ",
    address: "BDS | Exp. 6+ years",
    rating: "4.7",
    image: supriyadr,
     slug: "dr-supriya-Dental-aesthetic-consultant"
  },
  {
    id: 8 ,
    name: "DR.VEENA M",
    specialization: "Aesthetic Specialist | Homeopathy Specialist",
    address: "BHMS,FMC | Exp. 4+ years",
    rating: "4.8",
    image: veena,
     slug: "dr-veena-m-homeopathy-aesthetics-bangalore"
  },
  {
    id: 9,
    name: "DR.CHAYANIKA GHOSh",
    specialization: "Dental Specialist",
    address: "BDS | Exp. 4+ years",
    rating: "4.7",
    image: Chayanika,
    slug: "dr-chayanika-ghosh-dentist-jayanagar-bangalore"
    
  },
  {
    id: 10,
    name: "DR.M. R. ASHWINI",
    specialization: "Aesthetic Specialist | Homeopathy Specialist",
    address: "BHMS | Exp. 4+ years",
    rating: "4.7",
    image: aswini,
    slug: "dr-ashwini-mr-homeopathy-cosmetic-doctor-valasaravakkam-chennai"
  },
   {
    id: 11,
    name: "DR.VINITHA GOPI",
    specialization:  "Aesthetic Specialist | Homeopathy Specialist" ,
    address: "BHMS | Exp. 4+ years",
    rating: "4.7",
    image: vinithadoc,
     slug: "dr-vinitha-gopi-homeopathy-aesthetic-consultant-salem-tamilnadu"
  },
   {
    id: 12,
    name: "DR. KEETHANA M",
    specialization: "Aesthetic Specialist | Homeopathy Specialist",
    address: "BHMS ,  PGDCC and Trichology   | Exp. 3+ years",
    rating: "4.7",
    image: keerthanadoc,
     slug: "dr-m-keerthana-homeopathy-cosmetology"
  },
  // {
  //   id: 12  ,
  //   name: "DR. POOVIZHI DEVI",
  //   specialization: "Homeopathy Specialist",
  //   address: "BHMS ,  Functional Nutritionist | Exp. 3+ years",
  //   rating: "4.7",
  //   image: poovizhidoc,
  //    slug: "dr-poovizhi-devi-homeopathy-nutritionist"
  // },
   
  // {
  //   id: 8,
  //   name: "Dr.Ahilan Murugadas",
  //   specialization: "Aesthetic Specialist | Homeopathy Specialist",
  //   address: "BHMS , FMC , PGDDN | Exp. 4+ years",
  //   rating: "4.7",
  //   image: ahilan,
  //    slug: "dr-ahilan-murugadas-homeopathy-cosmetic-nutrition-gerugambakkam-chennai"
  // },
  // {
  //   id: 13,
  //   name: "DR.YUVAPRIYA P",
  //   specialization: "Aesthetic Specialist | Dental Specialist",
  //   address: "BDS,FMC | Exp. 2+ years",
  //   rating: "4.7",
  //   image: yuvapriya,
  //   slug: "dr-yuvapriya-p-dentist-aesthetic-jayanagar-bangalore"
  // },
  
  {
    id:13,
    name: "DR.YUGANTHI DURAI",
    specialization: "Aesthetic Specialist | Dental Specialist",
    address: "BDS, FFA, PGDMC | Exp. 2+ years",
    rating: "4.7",
    image: yuganthi,
    slug: "dr-yuganthi-durai-dentist-aesthetic-skin-hair-chennai"
  },
 
  // {
  //   id: 15,
  //   name: "DR.PARGAVI J",
  //   specialization: "Aesthetic Specialist | Homeopathy Specialist",
  //   address: "BHMS, FFAC | Exp. 2+ years",
  //   rating: "4.7",
  //   image: pargavi,
  //    slug: "dr-j-pargavi-homeopathy-aesthetic-doctor-jayanagar-bangalore"
  // }
  , {
    id: 14,
    name: "DR. UMA BARATHI S A",
    specialization: "Aesthetic Specialist | Homeopathy Specialist",
    address: "BHMS ,PGDCC  | Exp. 2+ years",
    rating: "4.7",
    image: umabarathidoc,
     slug: "dr-uma-barathi-homeopathy-aesthetic-chennai"
  },
  {
    id: 15,
    name: "DR. MOHAN SUNDAR",
    specialization: "Homeopathy Specialist",
    address: "BHMS , PGDMC | Exp. 2+ years",
    rating: "4.7",
    image: mohandr,
     slug: "dr-mohansundar-consultant"
  },
  {
    id: 16,
    name: "DR.NAVYA ANNAMANENI",
    specialization:  "Aesthetic Specialist | Dental Specialist",
    address: "BDS | Exp. 2+ years",
    rating: "4.7",
    image: navyadr,
     slug: "dr-navya-annamaneni-dentist-asthetic-guntur-andhrapradesh"
  } ,
   {
    id: 17,
    name: "DR.YUVASHREE G",
    specialization: "Homeopathy Specialist",
    address: "BHMS | Exp. 2+ years",
    rating: "4.7",
    image: yuvashreedr,
     slug: "dr-yuvashree-homeopathy-consultant"
  },
  //  {
  //   id: 13,
  //   name: "Dr.Muthumari M",
  //   specialization: "Aesthetic Specialist | Homeopathy Specialist",
  //   address: "BHMS , FFACC | Exp. 1+ years",
  //   rating: "4.7",
  //   image: muthumari,
  //    slug: "dr-muthumari-homeopathy-facial-aesthetics-valasaravakkam-chennai"
  // },
   {
    id: 18,
    name: "DR.AFILA JABBAR",
    specialization: "Homeopathy Specialist",
    address: "BHMS | Exp. 2+ years",
    rating: "4.7",
    image: afiladr,
     slug: "dr-afila-jabbar-chennai"
  },
   {
    id: 19,
    name: "DR.PAVITHRAKAMATCHI S M",
    specialization: "Aesthetic Specialist | Homeopathy Specialist",
    address: "BHMS  | Exp. 1+ years",
    rating: "4.7",
    image: pavithra,
     slug: "dr-pavithrakamatchi-tambaram-chennai"
  }
  ,{
    id: 20,
    name: "DR .DHARSHAN S",
    specialization: "Homeopathy Specialist",
    address: "BHMS  | Exp. 1+ years",
    rating: "4.7",
    image: dharshandoc,
     slug: "dr-s-dharshan-homeopathy-chennai"
  }
  ,{
    id: 21,
    name: "DR .SHARMILA",
    specialization: "Dental Specialist",
    address: "BDS  | Exp. 1+ years",
    rating: "4.7",
    image: sharmiladoc,
     slug: "dr-sharmila-bds-preventive-dentist-chennai"
  },{
    id: 22,
    name: "DR .INDHUMATHI M",
    specialization: "Homeopathy Specialist",
    address: "BHMS  | Exp. 1+ years",
    rating: "4.7",
    image: indhumathidoc,
     slug: "dr-indhumathi-m-bhms-yoga-homeopathy-chennai"
  }
  // ,{
  //   id: 17,
  //   name: "Dr .MOHAN SUNDAR",
  //   specialization: "Homeopathy Specialist",
  //   address: "BHMS , PGDMC | Exp. 1+ years",
  //   rating: "4.7",
  //   image: mohandr,
  //    slug: "dr-mohansundar-consultant"
  // }
  ,{
    id: 23,
    name: "DR .SNEGA M",
    specialization: "Dental Specialist",
    address: "BDS  | Exp. 1+ years",
    rating: "4.7",
    image: snegadoc,
     slug: "dr-snega-m-dentist-puducherry"
  },
  {
    id: 24,
    name: "DR .ABARNA K",
    specialization: "Homeopathy Specialist",
    address: "BHMS  | Exp. 1+ years",
    rating: "4.7",
    image: abarnadoc,
     slug: "dr-abarna-k-homeopathy-consultant"
  },
  
  //  {
  //   id: 27,
  //   name: "DR. MONEKA P",
  //   specialization: "Aesthetic Specialist | Homeopathy Specialist",
  //   address: "BHMS | Exp. 1+ years",
  //   rating: "4.7",
  //   image: monekadoc,
  //    slug: "dr-moneka-p-homeopathy-cosmetology"
  // },
  
  
//   {
//     id: 28,
//     name: "DR.SAI HARISHITHA",
//     specialization: "Homeopathy Specialist",
//     address: "BHMS | Exp. 1+ years",
//     rating: "4.7",
//     image: saiharishthadr,
//      slug: "dr-sai-harishitha-guntur"
//   }
// ,
  
  ,
  {
    id: 25 ,
    name: "DR.SHAHARIN BANU",
    specialization:  "Homeopathy Specialist" ,
    address: "BHMS | Exp. 1+ years",
    rating: "4.7",
    image: shaharinDoc,
     slug: "dr-shaharin-banu-homeopathy-consultant-puducherry"
  }
 
 
  
  
]

const Doctors = () => {
  useEffect(() => {
  document.title = "Our Doctors | Expert Homeopathy, Aesthetic & Dental Specialists - H-Cura";
  
  const metaDescription = document.querySelector("meta[name='description']");
  if (metaDescription) {
    metaDescription.setAttribute(
      "content",
      "Meet the expert medical team at H-Cura. Our specialists in Homeopathy, Aesthetics, and Dental care provide holistic and advanced treatments across Bangalore, Chennai, Salem, and Puducherry. Book your consultation today."
    );
  }

  const metaKeywords = document.querySelector("meta[name='keywords']");
  if (metaKeywords) {
    metaKeywords.setAttribute(
      "content",
      "best homeopathy doctors, aesthetic specialists, dental specialists, H-Cura team, homeopathy doctors Bangalore, skin specialists Chennai, dental experts, holistic healthcare professionals, top homeopathy clinic, aesthetic doctors near me"
    );
  }

  // Set canonical link
  const existingCanonical = document.querySelector("link[rel='canonical']");
  if (existingCanonical) {
    existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors-list/");
  } else {
    const canonicalLink = document.createElement("link");
    canonicalLink.setAttribute("rel", "canonical");
    canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors-list/");
    document.head.appendChild(canonicalLink);
  }

  // Set favicon
  const existingFavicon = document.querySelector("link[rel='icon']");
  if (existingFavicon) {
    existingFavicon.setAttribute("href", favicon);
  } else {
    const faviconLink = document.createElement("link");
    faviconLink.setAttribute("rel", "icon");
    faviconLink.setAttribute("type", "image/x-icon");
    faviconLink.setAttribute("href", favicon);
    document.head.appendChild(faviconLink);
  }
}, []);

  const [hoveredCard, setHoveredCard] = useState(null)
  const [selectedSpecialty, setSelectedSpecialty] = useState('All')
  const navigate = useNavigate();

  const specialties = ['All', 'Aesthetic Specialist', 'Homeopathy Specialist', 'Dental Specialist']

  const filteredDoctors = selectedSpecialty === 'All' 
    ? doctors 
    : doctors.filter(doctor => doctor.specialization.toLowerCase().includes(selectedSpecialty.toLowerCase()))

  return (
    <div className="doctorspage-container">
      {/* Hero Section */}
        <div className="doctorspage-hero-section">
        {/* Video Background */}
        <video
          className="doctorspage-hero-video-bg"
          src={hcuravideo}
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="doctorspage-hero-content">
          <h1 className="doctorspage-hero-title">
            Meet Our Expert Medical Team
          </h1>
          <p className="doctorspage-hero-subtitle">
            Dedicated professionals committed to your health and wellness journey
          </p>
          <div className="doctorspage-hero-stats">
            <div className="doctorspage-stat-item">
              <span className="doctorspage-stat-number">25+</span>
              <span className="doctorspage-stat-label">Expert Doctors</span>
            </div>
            <div className="doctorspage-stat-item">
              <span className="doctorspage-stat-number">100+</span>
              <span className="doctorspage-stat-label">Years Combined Experience</span>
            </div>
            <div className="doctorspage-stat-item">
              <span className="doctorspage-stat-number">4.7+</span>
              <span className="doctorspage-stat-label">Average Rating</span>
            </div>
          </div>
        </div>
        <div className="doctorspage-hero-pattern"></div>
      </div>

      {/* Filter Section */}
      <div className="doctorspage-filter-section ">
        <h3>Filter by Specialty</h3>
                      <div className="chennaiii-decorative-line"><span className="chennaiii-decorative-icon"><FaShieldAlt /></span></div>
        
        <div className="doctorspage-filter-buttons">
          {specialties.map((specialty) => (
            <button
              key={specialty}
              className={`doctorspage-filter-btn ${selectedSpecialty === specialty ? 'active' : ''}`}
              onClick={() => setSelectedSpecialty(specialty)}
            >
              {specialty}
            </button>
          ))}
        </div>
      </div>

      {/* Doctors Grid */}
      <div className="doctorspage-doctors-grid">
        {filteredDoctors.map((doctor, index) => (
          <div
            key={doctor.id}
            className={`doctorspage-doctor-card doctorspage-card-${index % 3}`}
            onMouseEnter={() => setHoveredCard(doctor.id)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div className="doctorspage-card-background"></div>
            
            <div className="doctorspage-doctor-image-container">
              <img 
                src={doctor.image} 
                alt={doctor.name}
                className="doctorspage-doctor-image"
              />
              <div className="doctorspage-image-overlay"></div>
              {/* <div className="doctorspage-rating-badge">
                <span className="doctorspage-star">★</span>
                <span>{doctor.rating}</span>
              </div> */}
            </div>

            <div className="doctorspage-doctor-info">
              <h3 className="doctorspage-doctor-name">{doctor.name}</h3>
              <p className="doctorspage-doctor-specialty">{doctor.specialization}</p>
              <p className="doctorspage-doctor-experience">{doctor.address}</p>
              
              <div className="doctorspage-card-actions">
                <button className="doctorspage-btn-primary" onClick={() => navigate('/bookconsultation')}>
                  <span>Book Appointment</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <button
              className="doctorspage-btn-secondary"
              onClick={() => navigate(`/doctors/${doctor.slug}`)}
            >
              View Profile
            </button>
              </div>
            </div>

            <div className="doctorspage-hover-effects">
              <div className="doctorspage-particle doctorspage-particle-1"></div>
              <div className="doctorspage-particle doctorspage-particle-2"></div>
              <div className="doctorspage-particle doctorspage-particle-3"></div>
            </div>
          </div>
        ))}
      </div>

      {/* Call to Action */}
      <div className="doctorspage-cta-section">
        <div className="doctorspage-cta-content">
          <h2>Ready to Start Your Health Journey?</h2>
          <p>Book a consultation with any of our expert doctors today</p>
          <button className="doctorspage-cta-button" onClick={() => navigate('/bookconsultation')}>
            Schedule Consultation
            <div className="doctorspage-button-shine"></div>
          </button>
        </div>
      </div>
    </div>
  )
}

export default Doctors
